export default __webpack_public_path__ + "static/media/Aakash-Dattani.85e514e8.png";